import { Button, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import FeilSideBilde from "@/assets/feil-side.webp?inline";
import { Page } from "@/components";

export const ErrorPage = () => {
  const { t } = useTranslation();
  return (
    <main className="w-full">
      <Page className="flex flex-row flex-wrap gap-4">
        <div className="space-y-4">
          <Heading level={1} data-size="lg">
            {t("feilmelding.overskrift")}
          </Heading>
          <Paragraph className="whitespace-pre-wrap">
            {t("feilmelding.beskrivelse")}
          </Paragraph>
          <Button variant="primary" onClick={() => window.location.reload()}>
            {t("feilmelding.prøv-igjen")}
          </Button>
        </div>

        <img
          className="mx-auto max-w-card w-full"
          src={FeilSideBilde}
          alt="Illustrasjon av fjernvarmeanlegg som har et problem"
        />
      </Page>
    </main>
  );
};
